import Container from '@/components/shared/Container'
import classNames from '@/utils/classNames'
import { APP_NAME } from '@/constants/app.constant'
import { PAGE_CONTAINER_GUTTER_X } from '@/constants/theme.constant'
import { useTranslation } from 'react-i18next'

export type FooterPageContainerType = 'gutterless' | 'contained'

type FooterProps = {
    pageContainerType: FooterPageContainerType
    className?: string
}

const FooterContent = () => {
    const { t } = useTranslation()

    return (
        <div className="flex items-center justify-between flex-auto w-full">
            <span>
                {t('footer.copyright', {
                    year: new Date().getFullYear(),
                    app: APP_NAME,
                })}
            </span>
            <div className="">
                <a
                    className="text-gray"
                    href="/#"
                    onClick={(e) => e.preventDefault()}
                >
                    {t('footer.terms')}
                </a>
                <span className="mx-2 text-muted"> | </span>
                <a
                    className="text-gray"
                    href="/#"
                    onClick={(e) => e.preventDefault()}
                >
                    {t('footer.privacy')}
                </a>
            </div>
        </div>
    )
}

export default function Footer({
    pageContainerType = 'contained',
    className,
}: FooterProps) {
    // `mb-20` clears the floating "Chat with AI" button (`AssistantLauncher`,
    // fixed `bottom-6`, `h-14`), which otherwise sat on top of Terms and
    // Privacy once the page was scrolled to the end (QA DEV-242).
    return (
        <footer
            className={classNames(
                `footer flex flex-auto items-center h-16 mb-20 ${PAGE_CONTAINER_GUTTER_X}`,
                className,
            )}
        >
            {pageContainerType === 'contained' ? (
                <Container>
                    <FooterContent />
                </Container>
            ) : (
                <FooterContent />
            )}
        </footer>
    )
}
